'use client'

import Head from "next/head";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FloatingContact } from "@/components/layout/FloatingContact";
import { site } from "@/content/site";
import { getOrganizationJsonLd, getPageSeo, getWebsiteJsonLd } from "@/lib/seo";
import { usePathname } from "next/navigation";
import React from 'react';

interface LayoutProps {
  title?: string;
  description?: string;
  image?: string;
  type?: string;
  noIndex?: boolean;
  jsonLd?: any;
  hideFooterForm?: boolean;
  children: React.ReactNode;
}

export function Layout({ title = "Swargaseema", description, image, type, noIndex, jsonLd, hideFooterForm, children }: LayoutProps) {
    const pathname = usePathname();
    const seo = getPageSeo({ title, description, image, path: pathname, type, noIndex });
    const structuredData = [getOrganizationJsonLd(site), getWebsiteJsonLd(site), ...(Array.isArray(jsonLd) ? jsonLd : [jsonLd])].filter(Boolean);

    return (
        <>
            <Head>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="robots" content={seo.robots} />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="canonical" href={seo.canonical} />
                <meta property="og:site_name" content={site.name} />
                <meta property="og:title" content={seo.openGraph.title} />
                <meta property="og:description" content={seo.openGraph.description} />
                <meta property="og:image" content={seo.openGraph.image} />
                <meta property="og:type" content={seo.openGraph.type} />
                <meta property="og:url" content={seo.openGraph.url} />
                <meta name="twitter:card" content={seo.twitter.card} />
                <meta name="twitter:title" content={seo.twitter.title} />
                <meta name="twitter:description" content={seo.twitter.description} />
                <meta name="twitter:image" content={seo.twitter.image} />
                {structuredData.map((item, index) => (
                    <script
                        key={`${item["@type"]}-${index}`}
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{ __html: JSON.stringify(item).replace(/</g, "\\u003c") }}
                    />
                ))}
            </Head>
            <Header />
            {children}
            <Footer hideForm={!!hideFooterForm} />
            <FloatingContact />
        </>
    );
}
